import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  configureProjectTools(
    data: Boundaries["configureProjectTools"]["request"],
  ): void;
}

function useConfigureProjectTools(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isConfigureProjectToolsRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isConfigureProjectToolsRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isConfigureProjectToolsRequestFailure,
    ),
    configureProjectTools: core.configureProjectTools,
  };
}

export { useConfigureProjectTools };
